import Loan from "typedef/Loan";
import CButton from "components/CButton";
import { Fragment } from "react";
import color from "context/MaterialUITheme/color";
import useDefineLoanType from "./useDefineLoanType";
import { Box, Typography } from "@mui/material";
import HELOCForm from "components/HELOCForm";

const TypeOfCreditLineOptions: React.FC<{ loan: Loan }> = ({ loan }) => {
  const offer = useDefineLoanType(loan);

  return (
    <Fragment>
      <HELOCForm {...offer} />
      <Box mt={3} py={2} bgcolor={color.white} borderRadius={8}>
        <Box px={{ xs: 2, md: 6 }} py={{ xs: 3, md: 5 }}>
          <Box
            mb={2}
            display={"flex"}
            alignItems={{ md: "center" }}
            justifyContent={"space-between"}
            flexDirection={{ xs: "column", md: "row" }}
          >
            <Box flex={1} textAlign={"left"} mb={{ xs: 1, md: 0 }}>
              <Typography
                variant="h5"
                color={color.black}
                fontFamily={"Pro Display Bold"}
              >
                Option 2: HELOAN
              </Typography>
            </Box>
            <Box
              flex={1}
              textAlign={{ xs: "left", md: "right" }}
              mb={{ xs: 1, md: 0 }}
            >
              <Typography variant="h6" color={color.black} fontSize={"1rem"}>
                <span
                  style={{
                    marginRight: 8,
                    fontSize: "1.5rem",
                    fontWeight: "bolder",
                    color: color.purple,
                  }}
                >
                  {((loan?.initialOffer?.interestRate ?? 0) * 100).toFixed(2)}%
                </span>
                {(
                  Math.round((loan?.initialOffer?.APR ?? 0) * 10000) / 100
                ).toFixed(2)}
                % APR
              </Typography>
            </Box>
          </Box>
          <Box>
            <Typography
              variant="h6"
              color={color.gray}
              textAlign={"justify"}
              fontFamily={"Pro Display Light"}
            >
              HELOAN is a one time, lump sum loan. Your payments will be fixed
              for a 25 year amortizing loan. Closing can be as fast as 8 days,
              and funding 3 days later.
            </Typography>
          </Box>

          <Box
            display={"flex"}
            flexDirection={{ xs: "column", md: "row" }}
            justifyContent={{ xs: "center", md: "left" }}
            alignItems={{ xs: "center", md: "left" }}
          >
            <Typography mt={{ xs: 2, md: 4 }} fontFamily={"Pro Display Light"}>
              <span
                style={{
                  fontFamily: "Pro Display Semibold",
                }}
              >
                Loan Amount:
              </span>{" "}
              <span
                style={{
                  color: color.purple,
                  fontFamily: "Pro Display Semibold",
                }}
              >
                $
                {Math.floor(loan?.initialOffer?.amount ?? 0).toLocaleString(
                  "en-US"
                )}
              </span>
            </Typography>
            <Typography
              mt={{ xs: 2, md: 4 }}
              fontFamily={"Pro Display Light"}
              display={{ xs: "none", md: "block" }}
            >
              <span
                style={{
                  marginLeft: 8,
                  marginRight: 8,
                  color: color.lightGray,
                  fontFamily: "Pro Display Semibold",
                }}
              >
                •
              </span>
            </Typography>
            <Typography mt={{ xs: 1, md: 4 }} fontFamily={"Pro Display Light"}>
              <span
                style={{
                  fontFamily: "Pro Display Semibold",
                }}
              >
                Monthly Payment:{" "}
              </span>{" "}
              <span
                style={{
                  color: color.purple,
                  fontFamily: "Pro Display Semibold",
                }}
              >
                $
                {Math.floor(
                  loan?.initialOffer?.monthlyPayment ?? 0
                ).toLocaleString("en-US")}
              </span>
            </Typography>
          </Box>

          <Box mt={4}>
            <CButton
              fullWidth
              type="submit"
              variant="contained"
              loading={offer.isAccepting}
              onClick={() => offer.saveOffer("HELOAN")}
            >
              Accept and Complete HELOAN Application
            </CButton>
          </Box>
          <Box mt={3}>
            <Typography mt={4} fontFamily={"Pro Display Light"}>
              <span
                style={{
                  fontFamily: "Pro Display Semibold",
                }}
              >
                Note:
              </span>{" "}
              for loans $68,908 and above, we will require an appraisal fee of $
              {Number(loan?.initialOffer?.appraisalFees).toLocaleString(
                "en-US"
              )}
              .
            </Typography>
          </Box>
          <Box mt={4}>
            <Typography
              variant="subtitle2"
              textAlign={"justify"}
              color={color.gray}
            >
              This letter is solely a pre-qualification for terms of a loan with
              NFTYDoor LLC, NMLS # 2324343, that you may be eligible for based
              on your stated information. This pre-qualification is not a
              commitment to lend or an approval of an application for credit
              with NFTYDoor. A written commitment to make a mortgage loan has
              not yet been issued. This is not a rate lock, and the APR,
              interest rate, and other related terms and conditions shown on
              this pre-qualification are sample terms only and are subject to
              change until you are approved for a loan and a commitment or loan
              offer is issued. In order for NFTYDoor to review your application
              for credit, you will need to submit a complete loan application
              and provide the information detailed above. Please note that the
              final terms and conditions of any loan offered to you will be
              based on NFTYDoor’s underwriting of and verification of the
              provided information. You are not required to obtain a loan from
              NFTYDoor just because you have received this pre-qualification.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Fragment>
  );
};

export default TypeOfCreditLineOptions;
